<template>
    <section class="tables">
        <vue-snotify></vue-snotify>
        <div class="row mt-5">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Resources Content</h4>
                    </div>
                    <div class="card-body">
                        <form class="forms-sample" enctype="multipart/form-data" @submit.prevent.stop="updateAwardContent" method="post"
                            autocomplete="off">
                            <div class="row mt-5">
                                <div class="col-md-12 d-flex align-items-stretch grid-margin">
                                    <div class="row flex-grow">
                                        <div class="col-12">
                                            <div class="">
                                                <div class="">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <div role="group" class="form-group">
                                                                <label for="GroupID" class="d-block">Group</label>
                                                                <div>
                                                                    <select class="custom-select" id="GroupID" v-model="awardId"
                                                                        required name="GroupID">
                                                                        <option v-for="(award,index) in awardOptions" :value="award.val"
                                                                            :key="index">{{ award.option }}</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md3">
                                                            <button class="btn btn-primary btn-sm mt-3"
                                                                @click.prevent="showAward">Show</button>
                                                        </div>
                                                    </div>
                                                    <div class="row" v-show="showSec">
                                                        <div class="col-md-12">
                                                            <div role="group" class="form-group">
                                                                <label for="Content1" class="d-block">Content Text 1</label>
                                                                <div>
                                                                    <ckeditor id="Content1" v-model="awardContentData.Content1" :config="editorConfig">
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.awardContentData.Content1.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div role="group" class="form-group">
                                                                <label for="Content2" class="d-block">Content Text 2
                                                                    2</label>
                                                                <div>
                                                                    <ckeditor id="Content2" v-model="awardContentData.Content2" :config="editorConfig1">
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.awardContentData.Content2.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div role="group" class="form-group">
                                                                <label for="Content3" class="d-block">Content Text 3</label>
                                                                <div>
                                                                    <ckeditor id="Content3" v-model="awardContentData.Content3" :config="editorConfig2">
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.awardContentData.Content3.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div role="group" class="form-group">
                                                                <label for="Content4" class="d-block">Content Text 4</label>
                                                                <div>
                                                                    <ckeditor id="Content4" v-model="awardContentData.Content4" :config="editorConfig3">
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.awardContentData.Content4.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div role="group" class="form-group">
                                                                <label for="Content5" class="d-block">Content Text 5</label>
                                                                <div>
                                                                    <ckeditor id="Content5" v-model="awardContentData.Content5" :config="editorConfig4">
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.awardContentData.Content5.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row" v-show="showSec">
                                                        <div class="col-md-6"></div>
                                                        <div class="col-md-6 mt-3">
                                                            <b-button type="submit" variant="success"
                                                                class="btn float-right btn-success">
                                                                Submit
                                                            </b-button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from "vue";
import API from '@/api'
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import CKEditor from 'ckeditor4-vue';

Vue.use(CKEditor);

export default {
    name: "webinar_content",
    mixins: [validationMixin],
    data() {
        return {
            showSec: false,
            awardOptions: [
                {
                    val: "",
                    option: "-- Please Select Award Winners --"
                }
            ],
            awardId: "",
            awardContentData: {
                Content1: "",
                Content2: "",
                Content3: "",
                Content4: "",
                Content5: "",
                val: ""
            },
            
            editorConfig: { 
                versionCheck: false 
            },
            editorConfig1: { 
                versionCheck: false 
            },
            editorConfig2: { 
                versionCheck: false 
            },
            editorConfig3: { 
                versionCheck: false 
            },
            editorConfig4: { 
                versionCheck: false 
            },
        }
    },
    validations: {
        awardContentData: {
            Content1: {
                required
            },
            Content2: {
                required
            },
            Content3: {
                required
            },
            Content4: {
                required
            },
            Content5: {
                required
            },
        }
    },
    methods: {

        updateAwardContent() {
            API.updateAwardContent(this.awardContentData,
                res => {
                    this.$showNotification({message:"Updated Successfully"}, 'success')
                }
                , this.errorCB);
        },
        showAward() {
            this.showSec = false;
            API.getAwardById({ id: this.awardId }, this.getAwardByIdCB, this.errorCB);
        },
        getAwardByIdCB(res) {
            this.awardContentData = res.data.data;
            this.showSec = true;
        },
        getAllAwards() {
            API.getAllAwards({withoutPagi:1}, this.getAllAwardsCB, this.errorCB);
        },
        getAllAwardsCB(res) {
            res.data.forEach(element => {
                this.awardOptions.push({
                    val: element.AwardID,
                    option: `${element.AwardFirstName} ${element.AwardLastName} -${element.Status}-${element.Year}`
                })
            });
        },
        errorCB(err) {
            console.log(err);
            this.$showNotification({ message: "Failed system error" }, 'error')
        },
    },
    mounted() {
        this.getAllAwards();
    },
    components: {}
}
</script>
